// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import IUser from "./IUser"
import GatewayClient from "./GatewayClient"


export default class AuthenticatedUser implements IUser {
  private client: GatewayClient
  private email: string
  private family_name: string
  private given_name: string

  constructor(client: GatewayClient, params: any) {
    this.client = client
    this.email = params.email
    this.family_name = params.family_name
    this.given_name = params.given_name
  }

  getEmail(): string {
    return this.email
  }

  getDisplayName(): string {
    let displayName = ""
    if (!!this.given_name && this.family_name) {
      displayName = this.given_name.substring(0,1)
        + this.family_name.substring(0, 1)
    } else if (this.email) {
      displayName = this.email.substring(0, 1)
    }
    return displayName
  }

  getFamilyName(): string {
    return this.family_name
  }

  getFullDisplayName(): string {
    return this.given_name || this.getDisplayName()
  }

  getGivenName(): string {
    return this.given_name
  }

  isAuthenticated(): boolean {
    return true
  }

  isLoaded(): boolean {
    return true
  }

  signout(): Promise<void> {
    return this.client.signout()
  }
}